import "core-js/modules/es6.array.find";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
export function add(state, data) {
  var products = state.products;
  var isExistQuantity = data.hasOwnProperty('totalQuantity');
  var isExistSuma = data.hasOwnProperty('sumaProduct');

  if (products.length === 0) {
    if (isExistQuantity && isExistSuma) {
      products.push(data);
    } else {
      var product = addProperties(data);
      products.push(product);
    }
  } else {
    var isExist = findProduct(products, data);

    if (!isExist) {
      var _product = addProperties(data);

      products.push(_product);
    } else {
      if (isExistQuantity && isExistSuma) {
        var _totalQuantity = data.totalQuantity;
        updateQuantity(products, data, _totalQuantity);
      } else {
        updateQuantity(products, data);
      }
    }
  }

  totalQuantity(state);
  subtotalProducts(state);
  setLocalStorage(state);
}
export function remove(state, data) {
  removeProduct(state.products, data);
  totalQuantity(state);
  subtotalProducts(state);
  setLocalStorage(state);
}
export function update(state, data) {
  updateTotalQuantity(state, data);
  totalQuantity(state);
  subtotalProducts(state);
  setLocalStorage(state);
}
export function addDelivery(state, data) {
  var delivery = parseFloat(data);
  state.delivery = delivery;
  state.total = state.subtotal + delivery;
  setLocalStorage(state);
}
export function clean(state) {
  state.products = [];
  state.subtotal = 0;
  state.total = 0;
  state.quantity = 0;
  state.delivery = 0;
  LocalStorage.clear();
  LocalStorage.set('products', []);
  LocalStorage.set('subtotal', 0);
  LocalStorage.set('total', 0);
  LocalStorage.set('quantity', 0);
  LocalStorage.set('delivery', 0);
}
export function localStorage(state, data) {
  state.products = data.products;
  state.subtotal = data.subtotal;
  state.total = data.total;
  state.quantity = data.quantity;
  state.delivery = data.delivery;
} // Functiones necesarias para el carrito de compras.

function addProperties(product) {
  var prod = JSON.parse(JSON.stringify(product));
  prod.totalQuantity = 1;
  prod.sumaProduct = prod.price * 1;
  return prod;
}

function findProduct(products, product) {
  return products.find(function (p) {
    return p.id === product.id;
  });
}

function updateQuantity(products, product) {
  var total = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  products.map(function (item) {
    if (product.id === item.id) {
      var t = total !== 0 ? total : 1;
      item.totalQuantity += t;
    }
  });
}

function totalQuantity(cart) {
  var prod = JSON.parse(JSON.stringify(cart));
  cart.quantity = 0;
  prod.products.map(function (item) {
    cart.quantity += item.totalQuantity;
  });
}

function subtotalProducts(cart) {
  var prod = JSON.parse(JSON.stringify(cart));
  var prodNormal = 0;
  cart.subtotal = 0;
  prod.products.map(function (item) {
    prodNormal += item.price * item.totalQuantity;
  });
  cart.subtotal += prodNormal;
}

function removeProduct(products, index) {
  products.splice(index, 1);
}

function setLocalStorage(state) {
  var cart = JSON.parse(JSON.stringify(state));
  LocalStorage.set('products', cart.products);
  LocalStorage.set('subtotal', cart.subtotal);
  LocalStorage.set('total', cart.total);
  LocalStorage.set('quantity', cart.quantity);
  LocalStorage.set('delivery', cart.delivery);
}

function updateTotalQuantity(state, data) {
  state.products.map(function (item) {
    if (data.id === item.id) {
      item.totalQuantity = data.value;
      var total = item.price * item.totalQuantity;
      item.sumaProduct = total;
    }
  });
}